/**
 * Provider identity helpers — no dependencies, safe anywhere.
 *
 * Their own module for the same reason as `marker.ts` and `msal-client.ts`:
 * reaching them through the barrel drags in `schemas.ts` and with it zod, which
 * a bundler cannot tree-shake away (#1982). Import `microsoft-auth/provider`
 * from anything that runs in a browser.
 */

export const AZURE_AD_PROVIDER_ID = 'azure-ad'

/**
 * Checks if a token/session object originated from the Azure AD provider.
 * Works with NextAuth tokens, custom JWTs, or any object with a `provider` field.
 */
export function isEntraUser(obj: { provider?: string } | null | undefined): boolean {
  return obj?.provider === AZURE_AD_PROVIDER_ID
}
